import { render, staticRenderFns } from "./ProductSpecificationTabs.vue?vue&type=template&id=02d7b95c&"
import script from "./ProductSpecificationTabs.vue?vue&type=script&lang=ts&"
export * from "./ProductSpecificationTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports